module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"profile":"Profile","profileAttributes":"Profile attributes","computedAttributes":"Computed attributes","incognitoProfile":"Incognito profile","name":"Name","value":"Value"},"ru":{"profile":"Профиль","profileAttributes":"Атрибуты профиля","computedAttributes":"Вычисляемые атрибуты","incognitoProfile":"Профиль инкогнито","name":"Название","value":"Значение"}}')
  delete Component.options._Ctor
}
